import React, { FunctionComponent } from "react";

import { Divider, makeStyles, MenuItem } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { RouteComponentProps, withRouter } from "react-router-dom";

import { FoodworksMenu } from "./FoodworksMenu";
import { signUserOut } from "../../store/thunks";

export interface CreateMenuProps {
  handleClose: () => void;
  anchorElement: HTMLElement | null;
  setShowAccountDialog: (showDialog: boolean) => void;
}

const useStyles = makeStyles(() => ({
  divider: { margin: "5px 0px" },
}));

export const AccountMenuInner: FunctionComponent<
  CreateMenuProps & RouteComponentProps
> = ({ history, handleClose, anchorElement, setShowAccountDialog }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const onUserLogout = () => dispatch(signUserOut(history));

  return (
    <FoodworksMenu
      id="simple-menu"
      anchorEl={anchorElement}
      open={Boolean(anchorElement)}
      onClose={handleClose}
    >
      <MenuItem
        onClick={() => {
          setShowAccountDialog(true);
        }}
      >
        Profile
      </MenuItem>

      <Divider className={classes.divider} />
      <MenuItem onClick={onUserLogout}>Log Out</MenuItem>
    </FoodworksMenu>
  );
};

export const AccountMenu = withRouter(AccountMenuInner);
